var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10402",
    "data-name": "Group 10402",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 35.553,
    viewBox: "0 0 33 35.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2365",
    "data-name": "Rectangle 2365",
    width: 33,
    height: 35.553,
    fill: "#101b2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10401",
    "data-name": "Group 10401",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29375",
    "data-name": "Path 29375",
    d: "M33,21.577a7.231,7.231,0,0,0-3.306-5.966c0-.029.015-.055.015-.084V11.894C29.709,5.34,23.784,0,16.522,0S3.328,5.34,3.328,11.894v3.633c0,.016.01.03.01.048A7.175,7.175,0,0,0,0,21.539c0,4.08,3.618,7.4,8.062,7.4a1.289,1.289,0,0,0,1.289-1.288V15.458A1.289,1.289,0,0,0,8.062,14.17a8.763,8.763,0,0,0-2.157.275v-2.55c0-5.1,4.761-9.275,10.618-9.275s10.611,4.122,10.611,9.275v2.563a8.662,8.662,0,0,0-2.194-.287,1.3,1.3,0,0,0-1.289,1.245V27.648a1.289,1.289,0,0,0,1.289,1.288,8.789,8.789,0,0,0,1.994-.235,2.509,2.509,0,0,1-2.413,1.856H21.3a3.513,3.513,0,0,0-3.252-2.185H15.5a3.525,3.525,0,0,0-3.526,3.511v.144A3.524,3.524,0,0,0,15.5,35.553h2.545a3.515,3.515,0,0,0,3.323-2.42h3.151a5.09,5.09,0,0,0,5.088-5.094v-.469A7.165,7.165,0,0,0,33,21.577M6.774,26.224a5,5,0,0,1-4.187-4.686,5.013,5.013,0,0,1,4.187-4.7Zm11.272,6.754H15.523a.948.948,0,0,1-.949-.951v-.144a.948.948,0,0,1,.949-.934h2.523a.933.933,0,0,1,.925.862c0,.012-.007.022-.007.034,0,.038.019.071.022.109v.074a.951.951,0,0,1-.94.951m8.18-6.754V16.837a5.013,5.013,0,0,1,4.187,4.7,5,5,0,0,1-4.187,4.686",
    transform: "translate(0 0)",
    fill: "#101b2d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon6);
export default __webpack_public_path__ + "static/media/social_icon6.87d279f23786b285e8549991df447839.svg";
export { ForwardRef as ReactComponent };